"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {

    props: ["currentFarm", "dico"],

    computed: {

        next: function next() {
            var index = this.getFarmIndex();
            var farms = this.getFarms();
            index++;
            if (index === farms.length) index = 0;
            return farms[index];
        },

        previous: function previous() {
            var index = this.getFarmIndex();
            var farms = this.getFarms();
            index--;
            if (index < 0) index = farms.length - 1;
            return farms[index];
        }

    },

    methods: {

        getFarmIndex: function getFarmIndex() {
            var _this = this;

            var farms = this.getFarms();
            return _lodash2.default.findIndex(farms, function (item) {
                return item.id === _this.currentFarm.config.id;
            });
        },

        getFarms: function getFarms() {
            return _lodash2.default.chain(this.dico.config).filter(function (item) {
                return item.id !== null;
            }).values().value();
        },

        getFarmPortrait: function getFarmPortrait(path) {
            return window.GLOBAL_CONFIG.baseUploadUrl.replace('__path__', path);
        }
    }

}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?{"presets":["es2015","stage-0"],"plugins":["transform-class-properties","transform-function-bind"]}!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/bottom/BottomComponent.vue
// module id = 391
// module chunks = 0